import React, { useEffect, useRef, useState } from 'react';
import { MdHelpOutline, MdPlayArrow, MdMenuBook } from 'react-icons/md';
import { useCoach } from './Coach';
import { useNavigate } from '../navIntent';
import './help.css';

/**
 * «كيف؟» in a page's header: the guides for the jobs done on this page,
 * each one a click away from its «ورّيني».
 */
export default function HelpButton({ guides: ids }) {
  const { guides, start, done } = useCoach();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const list = ids.map((id) => guides.find((x) => x.id === id)).filter(Boolean);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => { if (!rootRef.current?.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  if (!list.length) return null;

  return (
    <div ref={rootRef} className="hb">
      <button
        type="button"
        className={`hb-trigger${open ? ' is-open' : ''}`}
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        data-guide="page-help"
      >
        <MdHelpOutline size={18} /> <span>كيف؟</span>
      </button>
      {open && (
        <div className="hb-pop" role="menu">
          {list.map((x) => (
            <button
              key={x.id}
              type="button"
              role="menuitem"
              className="hb-item"
              onClick={() => { setOpen(false); start(x.id); }}
            >
              <span className={`help-icon help-tone-${x.tone}`}><x.icon size={18} /></span>
              <span className="hb-item-text">
                <strong>{x.title}</strong>
                <small>{done.includes(x.id) ? 'جرّبته من قبل · ' : ''}ورّيني خطوة بخطوة</small>
              </span>
              <MdPlayArrow className="hb-play" size={20} />
            </button>
          ))}
          <button type="button" className="hb-all" onClick={() => { setOpen(false); navigate('help'); }}>
            <MdMenuBook size={16} /> كل الأدلة
          </button>
        </div>
      )}
    </div>
  );
}
